// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AppIntroViewViewContentEvent
 */
export var AppIntroViewViewContent = function (_a) {
    var contents = _a.contents, currentContentId = _a.currentContentId, currentPageIndex = _a.currentPageIndex, guessedRegion = _a.guessedRegion;
    return ({
        name: "AppIntro View ViewContent",
        parameters: {
            cdf_entity: "AppIntro",
            cdf_action: "View",
            contents: contents !== undefined && contents !== null ? contents.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_content_id: currentContentId !== undefined && currentContentId !== null ? currentContentId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_page_index: currentPageIndex !== undefined && currentPageIndex !== null ? currentPageIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            guessed_region: guessedRegion !== undefined && guessedRegion !== null ? guessedRegion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AppIntroInteractCloseEvent
 */
export var AppIntroInteractClose = function () { return ({
    name: "AppIntro Interact Close",
    parameters: {
        cdf_entity: "AppIntro",
        cdf_action: "Interact",
    }
}); };
